import getSSP from '../lib/getServerSideProps';
import PageComponent from '../components/Page';

const Page = (props) => {
  return <PageComponent {...props} />;
};

export default Page;

export const getServerSideProps = getSSP('page');
